import React from 'react';
import {
    inject,
    observer
} from 'mobx-react';
import moment from 'moment';
var WOHistory = inject()(observer(function (props) {
    var woData = props.woData, noDataMsg = props.noDataMsg;
    return React.createElement(React.Fragment, null, woData && woData.length ? React.createElement('div', { className: 'rsp-home-wo-list' }, woData.map(function (wo) {
        return React.createElement('div', { className: 'rsp-home-wo py12 default-border default-padding' }, wo.serviceCodeIconUrl ? React.createElement('img', {
            className: 'wo-icon',
            src: wo.serviceCodeIconUrl
        }) : React.createElement('img', {
            className: 'wo-icon',
            src: 'https://rsp-front-end-stage.lessen.com/sources/svg/sc_default.svg'
        }), React.createElement('div', { className: 'ml-3' }, React.createElement('div', { className: 'f14' }, wo.serviceCategoryAliasId ? wo.serviceCodeAliasId ? wo.serviceCategoryAliasName + ' > ' + wo.serviceTypeAliasName + ' > ' + wo.serviceCodeAliasName : wo.serviceCategoryAliasName + ' > ' + wo.serviceTypeAliasName : wo.serviceCategoryName + ' > ' + wo.serviceTypeName + ' > ' + wo.serviceCodeName), React.createElement('div', { className: 'f12 wo-create-time' }, 'Created ', moment(wo.createDate).format('MMMM D, YYYY'))));
    })) : React.createElement('div', { className: 't-center d-flex justify-content-center align-items-center flex-column f14 h-100 rsp-home-nodata' }, React.createElement('div', { dangerouslySetInnerHTML: { __html: noDataMsg } }), React.createElement('img', {
        className: 'mt-2 no-data-icon',
        src: 'https://rsp-front-end-stage.lessen.com/sources/svg/home-woList-noData.svg'
    })));
}));
export default WOHistory;